var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[(_vm.Admin)?_c('zera-admin-dashboard'):_c('zera-staff-dashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }